import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { AdditionalIncomeService } from "../../../modules/statement/services/additional-income.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-simple-percent-field",
  templateUrl: "./simple-percent-field.component.html",
  styleUrls: ["./simple-percent-field.component.scss"],
  standalone: false
})
export class SimplePercentFieldComponent implements OnInit, OnDestroy {
  @Input() fieldsLabel = "Przychody";
  @Input() amountLabel = "Netto";
  @Input() resultLabel = "VAT";
  @Input() percentValue = null;
  @Input() initialAmount = null;
  @Input() placeholder = "";
  @Input() isDisabled = false;
  @Input() errorKey: string;

  @Output() modelChange = new EventEmitter<number>();
  @Output() calculatedChange = new EventEmitter<number>();

  constructor(
    private additionalIncomeService: AdditionalIncomeService,
    private translate: TranslateService
  ) {}

  errors: string[] | null = null;
  private sub: Subscription;
  amount = 0;
  percent = 0;
  calculated = null;

  ngOnInit() {
    // subskrypcja błędów
    if (this.errorKey) {
      this.sub = this.additionalIncomeService.errors$.subscribe((errs) => {
        const fieldErrors = errs?.filter((e) => e?.fieldName === this.errorKey) || [];
        this.errors = fieldErrors
          .flatMap((e) => e?.messages?.map((m) => this.translate.instant(m?.message)).filter(Boolean) || [])
          .filter(Boolean);
      });
    }

    this.amount = this.initialAmount;
    this.percent = this.percentValue;

    if (this.amount !== null && this.percent !== null) {
      this.recalculate();
    }
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  onAmountChange(value: number) {
    this.amount = value;
    this.modelChange.emit(this.amount);
    this.recalculate();
  }

  private recalculate() {
    if (this.amount && this.percent && /^\d+(\.\d+)?$/.test(String(this.amount))) {
      this.calculated = +(this.amount * (this.percent / 100)).toFixed(2);
    } else {
      this.calculated = 0;
    }
    this.calculatedChange.emit(this.calculated);
  }
}
